import { Component, Input, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { Popover, PopoverModule } from 'primeng/popover';

@Component({
    selector: 'app-mfa-info',
    imports: [
        RouterLink,
        ButtonModule,
        PopoverModule,
    ],
    templateUrl: './mfa-info.component.html',
    styleUrls: ['./mfa-info.component.scss'],
})
export class MfaInfoComponent {

    @Input() visible: boolean = true;
    @Input() loginContext: boolean = false;

    @ViewChild('mfaInfo') mfaInfo!: Popover;

    public toggle(event: Event): void {
        this.mfaInfo.toggle(event);
    }
}
